const routes = [{
    name: 'HelloWorld',
    path: '/',
    component: () =>
        import('@/components/HelloWorld'),
    meta: {
        indexheader: true,
        keepAlive: false,
        footerAlive: true,
    }
},

{
    name: 'theListOf',
    path: '/theListOf',
    component: () =>
        import('@/components/theListOf'),
    meta: {
        keepAlive: false,
        footerAlive: true,
    }
}, {
    name: 'indexheader',
    path: '/indexheader',
    component: () =>
        import('@/components/indexheader'),
    meta: {
        keepAlive: true,
        footerAlive: true,
    }
},


{
    name: 'liaoningTraffic',
    path: '/liaoningTraffic',
    component: () =>
        import('@/components/liaoningTraffic'),
    meta: {
        keepAlive: true,
        footerAlive: true,
    }
},


{
    name: 'projectDetails',
    path: '/projectDetails',
    component: () =>
        import('@/components/projectDetails'),
    meta: {
        keepAlive: true,
        footerAlive: true,
    }
},
{
    name: 'mylogin',
    path: '/mylogin',
    component: () =>
        import('@/components/mylogin'),
    meta: {
        keepAlive: false,
        footerAlive: true,
    }
}, {
    name: 'newlist',
    path: '/newlist',
    component: () =>
        import('@/components/newlist'),
    meta: {
        keepAlive: true,
        footerAlive: true,
    }
}, {
    name: 'informationForDetails',
    path: '/informationForDetails',
    component: () =>
        import('@/components/informationForDetails'),
    meta: {
        keepAlive: true,
        footerAlive: true,
    }
}, {
    name: 'registered',
    path: '/registered',
    component: () =>
        import('@/components/registered'),
    meta: {
        keepAlive: false,
        footerAlive: false,
        theSearchCriteria: null,
    }
}, {
    name: 'teachersPersonalCenter',
    path: '/teachersPersonalCenter',
    component: () =>
        import('@/components/teachersPersonalCenter'),
    meta: {
        keepAlive: true,
        footerAlive: true,
    }
}, {
    name: 'shareRanking',
    path: '/shareRanking',
    component: () =>
        import('@/components/shareRanking'),
    meta: {
        keepAlive: true,
        footerAlive: true,
    }
}, {
    name: 'personalCenterChangePasswords',
    path: '/personalCenterChangePasswords',
    component: () =>
        import('@/components/personalCenterChangePasswords'),
    meta: {
        keepAlive: true,
        footerAlive: true,
    }
}, {
    name: 'myCollection',
    path: '/myCollection',
    component: () =>
        import('@/components/myCollection'),
    meta: {
        keepAlive: true,
        footerAlive: true,
    }
}, {
    name: 'myComments',
    path: '/myComments',
    component: () =>
        import('@/components/myComments'),
    meta: {
        keepAlive: true,
        footerAlive: true,
    }
}, {
    name: 'myExperiment',
    path: '/myExperiment',
    component: () =>
        import('@/components/myExperiment'),
    meta: {
        keepAlive: true,
        footerAlive: true,
    }
}, {
    name: 'theExperimentalEvaluation',
    path: '/theExperimentalEvaluation',
    component: () =>
        import('@/components/theExperimentalEvaluation'),
    meta: {
        keepAlive: true,
        footerAlive: true,
    }
}, {
    name: 'forgotPassword',
    path: '/forgotPassword',
    component: () =>
        import('@/components/forgotPassword'),
    meta: {
        keepAlive: true,
        footerAlive: true,
    }
}, 



];

export default routes